import { Callout, CalloutTitle } from 'design-react-kit/dist/design-react-kit';

import { Icon } from '@arpav/components/ArpavTheme';
import PropTypes from 'prop-types';
import { RichText } from '@arpav/components/ArpavTheme/View';

const HelpBox = ({ text }) =>
  text ? (
    <Callout color="" highlight={false} tag="div">
      <CalloutTitle tag="div">
        <Icon
          color=""
          icon="it-info-circle"
          padding={false}
          size=""
          style={{
            ariaHidden: true,
          }}
        />
      </CalloutTitle>

      <p>
        <RichText content={text} />
      </p>
    </Callout>
  ) : null;

HelpBox.propTypes = {
  text: PropTypes.object.isRequired,
};

export default HelpBox;
